/*
 *   File : confirm-rebalance.js
 *   Author : https://evoqins.com
 *   Description : Confirm rebalance modal
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React from 'react';

//Custom components
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { Icon } from '../Icon';

//Style
import style from "../../Style/Component/modal.module.scss";

const ConfirmRebalanceModal = (props) => {

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("confirm-rebalance-modal-close");
        button.click();
        props.handleClose();
    };

    // handle confirm
    const _handleConfirm = () => {
        props.handleSuccess();
    };

    return (
        <div className="modal fade "
            id="confirm-rebalance-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="confirmRebalanceModalLabel"
            aria-hidden="true">

            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28">
                <span id='confirm-rebalance-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className={`${style.e_confirm_rebalance_modal} modal-content border-radius-28 overflow-hidden border-0`}>
                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-2">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            {props.success ? "Rebalance triggered successfully" : "Trigger rebalance"}
                        </h6>

                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className='modal-body pt-2 px-0 pb-0'>
                        {props.success ?
                            <div className='padding-32px-lr'>
                                <p className='mb-4 e-text-dark-gray e-primary-font e-font-16 e-font-weight-400 line-height-20px'>
                                    The <span className='e-font-weight-600'>conservative basket</span> has been successfully rebalanced. Users impacted: <span className='e-font-weight-600'>123</span>
                                </p>
                            </div>
                            :
                            <>
                                <div className='padding-32px-lr'>
                                    <p className='mb-4 e-text-dark-gray e-primary-font e-font-16 e-font-weight-400 line-height-20px'>
                                        Are you sure you want to trigger a rebalance for the <span className='e-font-weight-600'>{props.rebalanceData.style_name}</span>? This will adjust the fund allocations and impact all users invested in this basket.
                                    </p>

                                    <p className='mb-2 e-text-chinese-black e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                        Rebalance summary
                                    </p>
                                </div>
                                <div className='e-bg-cultured py-2 padding-32px-lr d-flex flex-column gap-10px'>
                                    {props.rebalanceData.funds.map((fund) => (
                                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px'>
                                            Added fund: <span className='pe-1 e-font-weight-500'>{fund.fund_name}</span>,<br />
                                            allocation: <span className='e-font-weight-500'>{fund.allocation}</span>
                                        </p>
                                    ))}

                                    <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px'>
                                        Changed allocation: <span className='pe-1 e-font-weight-500'>Bandhan Infrastructure Growth Plan</span>
                                        <span className='pe-1 e-font-weight-400'>30%</span>
                                        to
                                        <span className='ps-1 e-font-weight-500'>10%</span>
                                    </p>
                                </div>
                            </>
                        }
                    </div>

                    {/* Modal footer  */}
                    <div className={`${props.success ? ' padding-32px-lr  padding-32px-bottom pt-4' : ' padding-32px-all'} modal-footer border-0 gap-3`}>

                        {props.success ?
                            <SecondaryButton name="Ok"
                                className="py-3 padding-64px-lr"
                                onClick={_handleCloseModal} />
                            :
                            <>
                                <SecondaryButton name="Cancel"
                                    className="py-3 px-5"
                                    onClick={_handleCloseModal} />
                                <PrimaryButton name="Confirm"
                                    className="px-5"
                                    onClick={_handleConfirm} />
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConfirmRebalanceModal;

ConfirmRebalanceModal.defaultProps = {
    handleClose: () => { }
}